import { PageRoutes } from '../../../../app/pages/domain/constants/PageRoutes';
import { POI_URL_PARAM_ALL } from '../models/POILocations';
import { ILocationResponseItem } from '../../../../../common-data/models/ILocationResponseItem';
import { ICategoryResponseItem } from '../../../../../common-data/models/ICategoryResponseItem';
import { IPlacemarkResponseItem } from '../../../../../common-data/models/IPlacemarkResponseItem';

export const mapPoiItem = (
	poiItem: IPlacemarkResponseItem,
	poiCategoryMap: { [key: string]: ICategoryResponseItem },
	locationMap: { [key: string]: ILocationResponseItem },
) => ({
	id: poiItem.id,
	backgroundImage: poiItem.imageUrl,
	location: locationMap[poiItem.map].groupName,
	title: poiItem.name || poiItem.typeName || '',
	keywords: poiItem.keywords,
	linkHref: `${PageRoutes.Map}/?placemarkId=${poiItem.id}`,
	typeName: poiItem.typeName,
	type:
		poiItem.categoryIds
			.split(',')
			.map((categoryId) =>
				poiCategoryMap[categoryId]
					? poiCategoryMap[categoryId].name
					: undefined,
			)
			.filter((categoryName) => categoryName)[0] || POI_URL_PARAM_ALL,
});
